<template>
  <div class="activity-seckill">
    <van-nav-bar left-arrow left-text="返回" @click-left="$router.back()" title="拼团"></van-nav-bar>

    <div class="list mt-10">
      <!-- 单个商品 -->
      <van-cell>
        <router-link to="/product/detail" class="item flex jc-sb aic">
          <img class="img" src="../../../assets/img/miaosha-icon.png" alt />
          <div class="text fg1 h100pc flex2 jc-sb">
            <p class="title">
              <span class="red">
                <i class="iconfont icon-duorenyonghu-copy"></i> 多人团
              </span>
              <span class="ml-10">拼团-水果</span>
            </p>
            <div class="flex aic jc-sb">
              <p class="flex2 jc-c lh1">
                <span class="red">
                  <span class="f12">¥</span>
                  <span class="f16">100</span>
                  <s class="f999 f12">¥200</s>
                </span>
                <span class="f999 f12 mt-5">已团0件</span>
              </p>
              <span class="btn">去拼团</span>
            </div>
          </div>
        </router-link>
      </van-cell>
      <!-- 单个商品 -->
      <van-cell>
        <router-link to="/product/detail" class="item flex jc-sb aic">
          <img class="img" src="../../../assets/img/miaosha-icon.png" alt />
          <div class="text fg1 h100pc flex2 jc-sb">
            <p class="title">
              <span class="red">
                <i class="iconfont icon-duorenyonghu-copy"></i> 多人团
              </span>
              <span class="ml-10">拼团-水果</span>
            </p>
            <div class="flex aic jc-sb">
              <p class="flex2 jc-c lh1">
                <span class="red">
                  <span class="f12">¥</span>
                  <span class="f16">100</span>
                  <s class="f999 f12">¥200</s>
                </span>
                <span class="f999 f12 mt-5">已团0件</span>
              </p>
              <span class="btn">去拼团</span>
            </div>
          </div>
        </router-link>
      </van-cell>
      <!-- 单个商品 -->
      <van-cell>
        <router-link to="/product/detail" class="item flex jc-sb aic">
          <img class="img" src="../../../assets/img/miaosha-icon.png" alt />
          <div class="text fg1 h100pc flex2 jc-sb">
            <p class="title">
              <span class="red">
                <i class="iconfont icon-duorenyonghu-copy"></i> 多人团
              </span>
              <span class="ml-10">拼团-水果</span>
            </p>
            <div class="flex aic jc-sb">
              <p class="flex2 jc-c lh1">
                <span class="red">
                  <span class="f12">¥</span>
                  <span class="f16">100</span>
                  <s class="f999 f12">¥200</s>
                </span>
                <span class="f999 f12 mt-5">已团0件</span>
              </p>
              <span class="btn">去拼团</span>
            </div>
          </div>
        </router-link>
      </van-cell>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.activity-seckill {
  .lh1 {
    line-height: 1;
  }
  .title {
    .red {
      border: 1px solid @red;
    }
  }
  .text {
    height: 70px;
  }
  .van-cell {
    padding: 0;
  }
  .img {
    width: 120px;
    height: 120px;
  }
  .item {
    background: 1px solid;
  }
  .btn {
    background: linear-gradient(270deg, #ff3600, #ffae00);
    box-shadow: 0 0.02rem 0.08rem 0 rgba(255, 138, 0, 0.4);
    color: #fff;
    padding: 3px 15px;
    border-radius: 20px;
    margin-right: 15px;
  }
}
</style>